import { useCallback, useEffect, useState } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router';
import BasicButton from '../../../components/BasicButton';
import BasicInput from '../../../components/BasicInput';
import ImageUploader from '../../../components/ImageUploader';
import LoadingOverlay from '../../../components/LoadingOverlay';
import { downloadNewsCoverPhoto, uploadNews, useSpecificNews } from '../../../misc/lib/news';
import routes from '../../../misc/routes';
import NewsBodyEditor from '../UploadNewsPage/NewsBodyEditor';
import './EditNewsPage.scss';

const EditNewsPage = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const [ news, newsLoading ] = useSpecificNews(
    pathname.substring(pathname.lastIndexOf('/') + 1)
  );

  const [ title, setTitle ] = useState('');
  const [ coverPhoto, setCoverPhoto ] = useState<File>();
  const [ body, setBody ] = useState('');
  const [ uploading, setUploading ] = useState(false);

  const doUploadNews = useCallback(() => {
    if (!title || !coverPhoto || !body) return;

    setUploading(true);
    uploadNews(title, coverPhoto, body).then((id) => {
      history.push(routes.news.children.specificNews.path.replace(':id', id));
    }).catch((err) => {
      console.error(err);
    }).finally(() => {
      setUploading(false);
    });
  }, [ title, coverPhoto, body, history ]);

  useEffect(() => {
    if (!news) return;

    setTitle(news.title);
    setBody(news.body);

    downloadNewsCoverPhoto(news.id, news.coverPath).then((f) => {
      setCoverPhoto(f);
    }).catch((err) => {
      console.error(err);
    });
  }, [ news ]);

  // TODO: Add global error notification on this redirect
  return newsLoading ? <LoadingOverlay /> : !news ? (
    <Redirect to={ routes.admin.path } />
  ) : (
    <div className="uploadnewspage-container">
      <h1>Hír szerkeztése</h1>
      <BasicInput placeholder="Cím" text={ title } onTextChanged={ setTitle } />
      <ImageUploader img={ coverPhoto } onImgChanged={ setCoverPhoto } />
      <NewsBodyEditor text={ body } onTextChanged={ setBody } />
      <div className="format-guide"></div>
      <BasicButton text="Feltöltés" type="primary" onClick={ doUploadNews }
        working={ uploading } />
    </div>
  );
};

export default EditNewsPage;
